// extracted by mini-css-extract-plugin
export default {"title":"styles_title__kSH4l","content":"styles_content__EUwpK"};